// src/components/ResumeSection/ResumeSection.tsx
import React from "react";
import { ActiveButton } from "../aboutSection/ActiveButton";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { ArrowUpRightIcon } from "@heroicons/react/24/outline";
import AnimatedLine from "./AnimatedLine";

const ResumeSection: React.FC = () => {
  return (
    <section className="resume-section-wrapper min-w-xs max-w-5xl mx-auto p-8 bg-black ">
      <h2 className="text-white text-3xl font-bold mb-4">Resume</h2>

      <div className="resume-section-wrapper min-w-xs max-w-5xl mx-auto p-8 bg-black ">
        <ActiveButton
          href="https://www.scalosoft.com/"
          button={
            <div className="bg-black ml-4 mb-10 mr-4 w-full max-w-4xl ">
              <div className="w-full flex justify-between items-center mb-2 gap-2 text-gray-300">
                <span className="text-xl ">2024</span>
                <AnimatedLine className="h-px justify-self-stretch w-full bg-black sm:w-132 md:w-148 lg:w-156 ml-2 mr-2" />
                <span className="text-xl ">2025</span>
              </div>

              <div className="flex w-full justify-between items-center gap-2 text-white font-bold">
                <span className="group-hover:underline duration-500 text-white font-bold text-3xl sm:text-3xl flex items-center gap-1">
                  Front-End Developer
                  <ArrowUpRightIcon className="text-white stroke-[1] h-6 w-6 duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </span>
                <span className="text-white font-bold text-2xl sm:text-2xl">
                  Scalosoft
                </span>
              </div>

              <p className="w-full mt-4 text-base sm:text-xs md:text-base lg:text-base xl:text-lg font-thin leading-tight text-slate-50">
                Tackled a high 23% drop-off rate on the old jQuery medical
                survey by rebuilding the entirefrontend with React & TypeScript,
                aiming to bring the rate below 12% and modernize thetech
                stackAddressed slow updates and collaboration hurdles caused by
                the monolithic frontend byimplementing a Micro-Frontend
                architecture using Module Federation Vite, allowing teamsto
                release features independently and more quicklyImproved
                application reliability and caught integration bugs earlier by
                setting up a fulltesting suite, including Jest for components,
                Pact for API contracts, and Cypress for userjourney
                testingOptimized the survey's loading performance to meet the
                &lt3s TTI target on slow 3Gconnections through code splitting
                and lazy loading (React.lazy, Vite), making the userexperience
                much smootherEnhanced accessibility for screen reader users by
                fixing over 20 linting issues and usingcorrect semantic HTML,
                achieving WCAG 2.2 complianceEnabled safe A/B testing between
                different survey versions using feature flags (Unleash),
                discovering a layout that increased user completion rates by 7
                percentage pointsImplemented client-side tracing with
                OpenTelemetry JS to better diagnose performanceissues, helping
                pinpoint and fix slow GraphQL queries that impacted usersWorked
                closely with backend developers, medical staff, and legal
                experts to ensure allfrontend features strictly followed Swiss
                healthcare regulations (MDR, ePDK, GDPR)
              </p>

              <div className="mt-4 flex flex-wrap gap-6 text-sm sm:text-base text-gray-300">
                <div className="w-full flex flex-row justify-start">
                  <div className="flex w-full flex-col mr-2 items-start">
                    <span>React</span>
                    <AnimatedLine className="w-full h-px w-16 bg-black" />
                  </div>
                  <div className="flex w-full flex-col mr-2 items-start">
                    <span>JavaScript</span>
                    <AnimatedLine className="w-full h-px w-16 bg-black" />
                  </div>
                  <div className="flex w-full flex-col mr-2 items-start">
                    <span>Chart.js</span>
                    <AnimatedLine className="w-full h-px w-16 bg-black" />
                  </div>
                  <div className="flex w-full flex-col mr-2 items-start">
                    <span>Nginx</span>
                    <AnimatedLine className="w-full h-px w-16 bg-black" />
                  </div>
                </div>
              </div>
            </div>
          }
        />
      </div>

      <div className="group transition-colors resume-section-wrapper min-w-xs max-w-5xl mx-auto p-8 bg-black ">
        <ActiveButton
          href="https://evercity.io/"
          button={
            <div className="bg-black ml-4 mb-10 mr-4 w-full max-w-4xl ">
              <div className="w-full flex justify-between items-center mb-2 gap-2 text-gray-300">
                <span className="text-xl ">2023</span>
                <AnimatedLine className="h-px justify-self-stretch w-full bg-black sm:w-132 md:w-148 lg:w-156 ml-2 mr-2" />
                <span className="text-xl ">2024</span>
              </div>

              <div className="flex w-full justify-between items-center gap-2 text-white font-bold">
                <span className="group-hover:underline text-white font-bold text-3xl sm:text-3xl flex items-center gap-1">
                  Front-End Developer
                  <ArrowUpRightIcon className="text-white stroke-[1] h-6 w-6 duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </span>
                <span className="text-white font-bold text-2xl sm:text-2xl">
                  Evercity
                </span>
              </div>

              <p className="w-full mt-4 text-base sm:text-xs md:text-base lg:text-base xl:text-lg font-thin leading-tight text-slate-50">
                Developed a UI Kit with ready-to-use components to standardize
                interfaces across multiple projects. Built a discussion system
                to facilitate communication between companies within the
                platform. Implemented a report generation system fully compliant
                with EU regulations. Integrated automatic EU Taxonomy
                eligibility and alignment calculations using a webhook-based
                approach. Designed and implemented an administration panel and
                knowledge base to optimize internal processes. Developed
                analytical dashboards to visualize key performance metrics,
                enabling data-driven decision-making.
              </p>

              <div className="mt-4 flex flex-wrap gap-6 text-sm sm:text-base text-gray-300">
                <div className="w-full flex flex-row justify-start">
                  <div className="flex w-full flex-col mr-2 items-start">
                    <span>React</span>
                    <AnimatedLine className="w-full h-px w-16 bg-black" />
                  </div>
                  <div className="flex w-full flex-col mr-2 items-start">
                    <span>Rest API</span>
                    <AnimatedLine className="w-full h-px w-16 bg-black" />
                  </div>
                  <div className="flex w-full flex-col mr-2 items-start">
                    <span>JavaScript</span>
                    <AnimatedLine className="w-full h-px w-16 bg-black" />
                  </div>
                  <div className="flex w-full flex-col mr-2 items-start">
                    <span>WebSockets</span>
                    <AnimatedLine className="w-full h-px w-16 bg-black" />
                  </div>
                </div>
              </div>
            </div>
          }
        />
      </div>
      <div className="mb-4 ml-4 mr-10 mt-3">
        <div className=" flex justify-between border-2 bg-neutral-900 hover:bg-neutral-800 bg-neutral-900 border-zinc-600 h-55 w-full p-4 transition-colors no-underline ">
          <ActiveButton
            href="/resume.html"
            icon={
              <ArrowRightIcon className="self-end text-white stroke-[2] h-10 w-10 ml-3 transition-transform duration-500 ease-in-out group-hover:translate-x-4" />
            }
            button={
              <div className="transition-transform transform text-white items-start font-normal sm:text-xl  md:text-2xl lg:text-4xl xl:text-4xl flex flex-col ml-3">
                <div className="relative overflow-hidden w-full sm:h-6 md:h-7 lg:h-10 xl:h-10">
                  <p className=" duration-500 ease-in-out  sm:group-hover:-translate-y-6 md:group-hover:-translate-y-7 lg:group-hover:-translate-y-10 xl:group-hover:-translate-y-10 flex flex-col">
                    <span>View</span>
                    <span>View</span>
                  </p>
                </div>
                <div className="h-2"></div>
                <div className="relative overflow-hidden w-full sm:h-6 md:h-7 lg:h-10 xl:h-10">
                  <p className="duration-500 delay-150 ease-in-out  sm:group-hover:-translate-y-6 md:group-hover:-translate-y-7 lg:group-hover:-translate-y-10 xl:group-hover:-translate-y-10 flex flex-col">
                    <span>Full Resumé</span>
                    <span>Full Resumé</span>
                  </p>
                </div>
                <div className="h-2"></div>
              </div>
            }
          />
        </div>
      </div>
    </section>
  );
};

export default ResumeSection;
